import * as React from 'react'

import { Box, Button, Tag, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TimePicker from 'modules/core/components/Inputs/TimePicker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

const Separator = () => <Box padding="s4">-</Box>

export interface Props {
  form: Form
  isNotValid: boolean
  isOvernight: boolean
  onBlur?: (e: React.SyntheticEvent<unknown>) => unknown
  onDelete: (e: React.SyntheticEvent<unknown>) => unknown
  clearInput?: () => void
}

const ShiftPicker = (props: Props) => {
  const [focus, setFocus] = React.useState(false)
  const { access } = useCurrentSession()
  const isTimeFormat24H = access.timeFormat === 24

  const onFocus = () => {
    setFocus(true)
  }

  const onKeyDown = () => {
    if (props.clearInput) props.clearInput()
  }

  const onBlur = (e: React.SyntheticEvent<unknown>) => {
    setFocus(false)

    if (props.onBlur) props.onBlur(e)
  }

  return (
    <Box>
      <Box flexDirection="row" gap="s16">
        <Box flexDirection="row" alignItems="center">
          <TimePicker
            field={props.form.get('start_at')}
            isTimeFormat24H={isTimeFormat24H}
            isNotValid={props.isNotValid}
            hideError
            focused={focus}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
          />
          <Separator />
          <TimePicker
            field={props.form.get('end_at')}
            isTimeFormat24H={isTimeFormat24H}
            isNotValid={props.isNotValid}
            focused={focus}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
          />
        </Box>
        {props.isOvernight && (
          <Box alignItems="center" flexDirection="row">
            <Tag type={Tag.Types.grey}>{i18n.t('shift_management.plus_1_day_tag')}</Tag>
          </Box>
        )}
        <Box justifyContent="center">
          <Button type="secondary" onClick={props.onDelete} iconName="delete" />
        </Box>
      </Box>
      <Box justifyContent="flexStart">
        {props.isNotValid && !focus && (
          <Text size="200" color="radicalRed1000" capitalize>
            {i18n.t('shift_management.templates.weeks.errors.incomplete_shift')}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default observer(ShiftPicker)
